<template>
	<button type="button" class="ov-dropdown-item" @click="$emit('click', $event)">
		<slot />
	</button>
</template>

<script>
export default {
	name: "OvDropdownItem",
	emits: ["click"],
};
</script>

<style lang="scss" scoped>
.ov-dropdown-item {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	padding: 8px 14px;
	font-size: var(--ds-font-size-sm);
	font-family: inherit;
	color: var(--ds-color-text);
	background: none;
	border: none;
	text-align: left;
	cursor: pointer;

	&:hover {
		background: var(--ds-color-bg);
	}
}
</style>
